const getHourAbbreviation = (languageId: string): string => (languageId === '1' ? 'u' : 'h');

export const formatDeviation = (minutes: number, languageId: string): string => {
  const absMinutes = Math.abs(minutes);
  const hours = Math.floor(absMinutes / 60);
  const remainingMinutes = absMinutes % 60;
  const sign = minutes >= 0 ? '+' : '\u2212';
  const h = getHourAbbreviation(languageId);

  if (hours > 0) {
    return `${sign}${hours} ${h} ${String(remainingMinutes).padStart(2, '0')} min`;
  }
  return `${sign}${remainingMinutes} min`;
};

export const formatTotalHours = (minutes: number, languageId: string): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const h = getHourAbbreviation(languageId);
  return `${hours} ${h} ${String(remainingMinutes).padStart(2, '0')} min`;
};
